module.exports = __webpack_public_path__ + "img/banner-2.4a4cda2b.jpg";